/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type BulkManageSchedule_CustomerFragment = { __typename: 'Customer', id: string, schedules: Array<{ __typename: 'Schedule', id: string, title: string, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', type: Types.TimeBlockType, data: { __typename: 'ScheduleTimeBlockData', mediaType?: string | null } }> }> };

export type BulkManageUpdateScheduleMutationVariables = Types.Exact<{
  input: Types.DisplayBulkUpdateScheduleInput;
}>;


export type BulkManageUpdateScheduleMutation = { __typename: 'Mutation', displayBulkUpdateSchedule: { __typename: 'DisplayBulkUpdateSchedulePayload', displays: Array<{ __typename: 'Display', id: string, schedule?: { __typename: 'DisplaySchedule', schedule?: { __typename: 'Schedule', id: string, title: string } | null } | null }> } };

export const BulkManageSchedule_CustomerFragmentDoc = gql`
    fragment BulkManageSchedule_customer on Customer {
  id
  schedules {
    id
    title
    timeBlocks {
      type
      data {
        mediaType
      }
    }
  }
}
    `;
export const BulkManageUpdateScheduleDocument = gql`
    mutation BulkManageUpdateSchedule($input: DisplayBulkUpdateScheduleInput!) {
  displayBulkUpdateSchedule(input: $input) {
    displays {
      id
      schedule {
        schedule {
          id
          title
        }
      }
    }
  }
}
    `;
export type BulkManageUpdateScheduleMutationFn = ApolloReactCommon.MutationFunction<BulkManageUpdateScheduleMutation, BulkManageUpdateScheduleMutationVariables>;

/**
 * __useBulkManageUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useBulkManageUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkManageUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkManageUpdateScheduleMutation, { data, loading, error }] = useBulkManageUpdateScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkManageUpdateScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkManageUpdateScheduleMutation, BulkManageUpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkManageUpdateScheduleMutation, BulkManageUpdateScheduleMutationVariables>(BulkManageUpdateScheduleDocument, options);
      }
export type BulkManageUpdateScheduleMutationHookResult = ReturnType<typeof useBulkManageUpdateScheduleMutation>;
export type BulkManageUpdateScheduleMutationResult = ApolloReactCommon.MutationResult<BulkManageUpdateScheduleMutation>;
export type BulkManageUpdateScheduleMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkManageUpdateScheduleMutation, BulkManageUpdateScheduleMutationVariables>;